const PRODUCT_FALLBACK = "/public/img/itemImage.png";
const CATEGORY_FALLBACK = "/public/img/categoryImage.png";

/** Cached HTTP image for a sale category (product.category id). */
export function productImageUrl(productId) {
    if (productId == null) return PRODUCT_FALLBACK;
    return `/product-image/${productId}.jpg`;
}

/** Cached HTTP cover for a main category (product.category.type id). */
export function categoryCoverUrl(categoryId) {
    if (categoryId == null) return CATEGORY_FALLBACK;
    return `/category-image/${categoryId}.jpg`;
}

/** Slider banner served from Odoo via same-origin proxy. */
export function sliderImageUrl(imageId) {
    if (imageId == null) return null;
    return `/slider-image/${imageId}.jpg`;
}

/** Product tile / card src — prefer URL over inline base64. */
export function productImageSrc(product) {
    if (!product) return PRODUCT_FALLBACK;
    if (product.id != null && product.image) return productImageUrl(product.id);
    if (product.image) return `data:image/jpeg;base64,${product.image}`;
    return PRODUCT_FALLBACK;
}

/** Main category cover — prefer URL over inline base64. */
export function categoryCoverSrc(category) {
    if (!category) return CATEGORY_FALLBACK;
    if (category.id != null && category.cover_image) return categoryCoverUrl(category.id);
    if (category.cover_image) return `data:image/jpeg;base64,${category.cover_image}`;
    return CATEGORY_FALLBACK;
}
